export const API_URL = {
  houseDetail: (slug: string) => `/houses?slug=${slug}` as const,
  vendorDetail: (vendorNid: string) => `/vendors?nid=${vendorNid}` as const,
  vendorReview: (vendorNid: string) =>
    `users/current/review/${vendorNid}` as const,
  externalReview: (reviewId: string) =>
    `reviews/external-update/${reviewId}` as const,
  allHousesByVendor: (vendorNid: string) =>
    `/haeuser/suche/?vendor_nid__in=${vendorNid}` as const,
  otherHousesByVendor: (vendorNid: string, limit: number) =>
    `/houses?vendor_nid__in=${vendorNid}&limit=${limit}` as const,
  houses: '/houses' as const,
  salesOfficeData: (vendorNid: string, postcode: string) =>
    `/sales-offices?vendor_nid=${vendorNid}&display_delivery_regions__contains=${postcode}` as const,
  similarHouses: (houseNid: string) =>
    `/similar-houses/?house_nid=${houseNid}` as const,
  vendorReviews: (vendorNid: string) => `/reviews/vendor/${vendorNid}` as const
}
